import type { VariantProps } from "class-variance-authority"
import { cva } from "class-variance-authority"

export const fieldVariants = cva(
    "group/field flex w-full gap-x-4 gap-y-2 data-[invalid=true]:text-destructive",
    {
        variants: {
            layout: {
                vertical: [
                    "flex-col [&>*]:w-auto [&>.sr-only]:w-auto",
                    "[&>[data-slot=label]]:w-auto [&>[data-slot=label]]:mr-auto max-w-full",
                    "[&>[data-slot=field-content]]:pt-0.5",
                    "[&>[data-slot=field-content]]:max-w-full",
                    "[&>[data-slot=field-content]>*]:w-auto",
                ],
                horizontal: [
                    "flex-row items-start [&.compact]:items-center",
                    "[&>*]:w-auto",
                    "has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px",
                ],
                responsive: [
                    "flex-col [&>*]:w-full [&>.sr-only]:w-auto @md/field-group:flex-row @md/field-group:items-center @md/field-group:[&>*]:w-auto",
                    "@md/field-group:has-[>[data-slot=field-content]]:items-start @md/field-group:has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px",
                ],
                'inline': [
                    "flex-row items-center gap-(--field-gap-x) flex-none mr-auto w-auto",
                    "[&>[data-slot=field-content]]:flex-none",
                    "[&>[data-slot=field-content]]:pt-1.5",
                    "items-start has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px",
                ],
                'inline-reverse': [
                    "flex-row-reverse items-center gap-(--field-gap-x) flex-none mr-auto w-auto",
                    "[&>[data-slot=field-content]]:flex-none",
                    "[&>[data-slot=field-content]]:pt-1.5",
                    "items-start has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px",
                ],
            },

            compact: {
                false: "",
                true: [
                    'compact',
                    "w-fit [&>*]:w-fit [&>*]:flex-none",
                    "[&>[data-slot=field-content]>*]:w-fit [&>[data-slot=field-content]>*]:flex-[0_1_auto]",
                    "[&>[data-slot=field-content]]:flex-[0_1_auto]!",
                    "**:[[data-slot=input-group-control]]:flex-none"
                ],
            },
        },
        defaultVariants: {
            layout: "vertical",
            compact: false,
        },
    },
)

export type FieldVariants = VariantProps<typeof fieldVariants>
